import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import label from '../utils/constants/label';

const steps = [label.stepper.stepOne, label.stepper.stepTwo, label.stepper.stepThree];

export default function HorizontalNonLinearStepper(props) {
    const classes = useStyles();

    return (
        <Box sx={{ width: '100%' }}>
            <Stepper nonLinear activeStep={props.activeStep} className={classes.stepper}>
                {steps.map((label, index) => (
                    <Step key={label} completed={props.completed[index]}>
                        <StepButton style={{ color: "red" }}>
                            {label}
                        </StepButton>
                    </Step>
                ))}
            </Stepper>
        </Box>
    )
}

const useStyles = makeStyles({
    stepper: {
        "& .MuiStepIcon-root.Mui-active": {
            fontWeight: 600,
            color: "#f7941d"
        },
        "& .MuiStepIcon-root.Mui-completed ": {
            fontWeight: 600,
            color: "#f7941d"
        },


    }

});